<template>
  <v-dialog v-model="dialogVisible" max-width="600px" persistent>
    <v-card class="team-details-card">
      <v-toolbar class="dialog-header">
        <v-toolbar-title>
          <v-icon>mdi-account-group</v-icon>
          Team Details
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon="mdi-close" @click="closeDialog" class="close-btn"></v-btn>
      </v-toolbar>

      <v-card-text class="dialog-content">
        <div v-if="team" class="team-details">
          <div class="detail-section mb-6">
            <h3 class="section-title mb-4">
              <v-icon size="20" color="primary" class="mr-2">mdi-domain</v-icon>
              Organization Information
            </h3>
            <v-row>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Team ID:</label>
                  <span class="detail-value">{{
                    team.organization_display_id
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Organization Name:</label>
                  <span class="detail-value">{{ team.organization_name }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Status:</label>
                  <v-chip
                    :color="
                      team.organization_type === 'LIVE' ? 'success' : 'warning'
                    "
                    size="small"
                    variant="flat"
                    class="status-chip"
                  >
                    {{ team.organization_type }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Created On:</label>
                  <span class="detail-value">{{
                    formatDate(team.organization_created_on * 1000)
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </div>

          <div class="detail-section mb-6">
            <h3 class="section-title mb-4">
              <v-icon size="20" color="primary" class="mr-2"
                >mdi-account-circle</v-icon
              >
              Contact Information
            </h3>
            <v-row>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Created By:</label>
                  <span class="detail-value">{{
                    team.organization_created_by
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Default Timezone:</label>
                  <span class="detail-value">{{
                    team.default_timezone || "Not set"
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="detail-item">
                  <label class="detail-label">Bucket Region:</label>
                  <span class="detail-value">{{
                    team.bucket_region || "Not set"
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Additional Details -->
          <div
            class="detail-section"
            v-if="team.organization_country || team.organization_team_id"
          >
            <h3 class="section-title mb-4">
              <v-icon size="20" color="primary" class="mr-2"
                >mdi-information</v-icon
              >
              Additional Details
            </h3>
            <v-row>
              <v-col cols="12" md="6" v-if="team.organization_country">
                <div class="detail-item">
                  <label class="detail-label">Country:</label>
                  <span class="detail-value">{{
                    team.organization_country
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="6" v-if="team.organization_team_id">
                <div class="detail-item">
                  <label class="detail-label">Team ID:</label>
                  <span class="detail-value">{{
                    team.organization_team_id
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TeamDetailsDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    team: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    closeDialog() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.team-details-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.dialog-header {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
  color: white;
  padding: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  color: white !important;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
}

.dialog-content {
  padding: 32px;
  background-color: #fafbfc;
}

.detail-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
}

.section-title {
  color: #2c3e50;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.detail-item {
  margin-bottom: 16px;
}

.detail-label {
  display: block;
  font-weight: 600;
  color: #6c757d;
  font-size: 0.875rem;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  display: block;
  color: #212529;
  font-size: 1rem;
  font-weight: 500;
}

.status-chip {
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  border-radius: 6px;
  min-width: 80px;
  text-align: center;
  justify-content: center;
}

.dialog-footer {
  background: white;
  padding: 24px 32px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.action-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 8px;
  padding: 12px 24px;
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dialog-content {
    padding: 24px 20px;
  }

  .detail-section {
    padding: 20px;
  }

  .dialog-footer {
    padding: 20px;
  }
}
</style>
